export enum NotificationStatus{
    Open = 'Open',
    // Hold='Hold',
    // Inprogress='Inprogress',
    Pending = 'Pending',
    Closed = 'Closed',
    Cancelled = 'Cancelled'
}